import { axiosFn, handleError } from "../index";
import * as URL from "../URLs";

export async function getProfileDetails(id) {
  return await axiosFn("get", URL.ADMINUSERS + "/" + id)
    .then((res) => {
      return {
        res: res.data,
        err: null,
      };
    })
    .catch(handleError);
}
